import { render, staticRenderFns } from "./vtopimages.vue?vue&type=template&id=a605371a&scoped=true&"
import script from "./vtopimages.vue?vue&type=script&lang=js&"
export * from "./vtopimages.vue?vue&type=script&lang=js&"
import style0 from "./vtopimages.vue?vue&type=style&index=0&id=a605371a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a605371a",
  null
  
)

export default component.exports